import { OrdStatusEnum } from '../types/types';

export const isOrderRejected = (ordStatus: OrdStatusEnum) => ordStatus === OrdStatusEnum.Rejected;
